<app-nav-bar></app-nav-bar>
<div class="tab" role="tabpanel" aria-labelledby="pills-contact-tab">

    <div class="scheduleConference">
     <div class="split left">
     <br>
     <br>
       <span style="font-size: 30px;font-weight: 600;color: #004526;font-family: 'Rubik', sans-serif;">
         Contact Us
         </span>
         <br>
         <br>
         <p style="font-size: 18px;color:#6d6868;" >For questions about our company and service found on our company.</p>
         <br>
         <br>
         <div class="row">
           <div class="col-12 col-md-12 col-lg-6">
           <h4 style="font-size: 22px;font-weight: 600;color: #6d6868;font-family: FontAwesome;">Contact</h4>
           <p style="font-size: 18px;color:#6d6868;" ><img src="../../assets/images/phone.png"  height="19px"> +91 8957926677</p>
           <p style="font-size: 18px;color:#6d6868;" ><img src="../../assets/images/email.png" height="13px"> info@criteriontech.in</p>
           </div>
           <div class="col-12 col-md-12 col-lg-6 ">
           <h4 style="font-size: 22px;font-weight: 600;color: #6d6868;font-family: FontAwesome;"><img src="../../assets/images/address.png"></h4>
           <p style="font-size: 18px;color:#6d6868;" >
             Company address
             <br>Sarfarazganj, Hardoi Road,
             <br>Lucknow-226003
           </p>
           
           </div>
           </div>
           <br>
          
           <h4 style="font-size: 22px;font-weight: 600;color: #6d6868;font-family: FontAwesome;">Connect With Us</h4>
           
           <div class="socialMedia">
            <a href="https://www.facebook.com/CriterionTech/" target="_blank" title="facebook" class="fab fa-facebook-square" id="fb"></a>&nbsp;&nbsp;
            <a href="https://twitter.com/criterion_tech" target="_blank" title="twitter" class="fab fa-twitter-square" id="twitter"></a>&nbsp;&nbsp;
            <!-- <a href="https://www.instagram.com/cri_terion_tech/" target="_blank" title="instagram" class="fab fa-instagram-square" id="insta"></a> -->
            <a href="https://www.instagram.com/cri_terion_tech/" target="_blank" title="instagram" class="fa fa-instagram fa-3x social" id="insta"></a>
            <!-- <a href="https://instagram.com"><i id="social-in" class="fa fa-instagram fa-3x social" aria-hidden="true"></i></a> -->
            &nbsp;&nbsp;
            <a href="https://www.linkedin.com/in/criterion-tech-99048a1a4/" target="_blank" title="linkedin" class="fab fa-linkedin" id="linkedin"></a>&nbsp;&nbsp;
   
           
            </div>
     </div>
     
     <div class="split right"> 
       <br>
       <br>
       <span style="font-size: 25px;font-weight: 600;color: #004526; margin-left: 10px;font-family: 'Rubik', sans-serif;"> Get in touch</span>
       <br>
       <!-- <a href="https://www.instagram.com/cri_terion_tech/" target="_blank" title="instagram" class="fab fa-instagram-square" id="insta"></a> -->
       <br>
       <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
       <span>
         <input type="text" name="fullName" id="fullName" class="form-control" placeholder="&#xf007;&nbsp;&nbsp;Full Name" style="font-family: FontAwesome;" 
          [(ngModel)]="model.fullName" #fullName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }" required />
         <div *ngIf="f.submitted && fullName.invalid" class="invalid-feedback">
           <div *ngIf="fullName.errors.required" style="font-size: 15px;">*Full Name is required</div>
       </div>
       </span>
       <br>
       <span>
         <input type="text" name="email" id="email" class="form-control" placeholder="&#xf0e0;&nbsp;&nbsp;Email" style="font-family: FontAwesome;"  
         [(ngModel)]="model.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
         <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
           <div *ngIf="email.errors.required" style="font-size: 15px;">*Email is required</div>
           <div *ngIf="email.errors.email" style="font-size: 18px;">*Email must be a valid email address</div>
       </div>
       </span>
       <br>
       <span>
         <textarea id="msg" name="message" class="form-control"  placeholder="Message" 
         [(ngModel)]="model.msg" #msg="ngModel" [ngClass]="{ 'is-invalid': f.submitted && msg.invalid }" required></textarea>
         <div *ngIf="f.submitted && msg.invalid" class="invalid-feedback">
          <div *ngIf="msg.errors.required" style="font-size: 15px;">*Message is required</div>
      </div>
        
        

       </span>
     <br>
     
     <button type="submit" class="btnSend">
     <i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;
     Send
     </button>
    </form>
   
   
     </div>
     
     </div>
   
   </div>